import { render, staticRenderFns } from "./rmib-group.vue?vue&type=template&id=2d5f9575&"
import script from "./rmib-group.vue?vue&type=script&lang=js&"
export * from "./rmib-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports